"use client";
import { j as v } from "./jsx-runtime-CJ-St4mQ.mjs";
import * as n from "react";
import { forwardRef as U } from "react";
import { t as H } from "./tv.config-BuYIgndg.mjs";
import { useMediaQuery as K } from "./useMediaQuery.js";
import { O as Q } from "./Option-Omg-vJyi.mjs";
import { o as S } from "./owner-DpSCkBia.mjs";
import { u as T } from "./useEventCallback-CjuAhyNz.mjs";
import { u as W } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as q } from "./useBaseUiId-a-UPSsPQ.mjs";
import { u as z } from "./useRenderElement-B8V3_e8R.mjs";
import { A as G } from "./constants-BtlZRkCt.mjs";
import { u as J } from "./useCompositeItem-qvQDnnMp.mjs";
import { u as X } from "./TabsRootContext-CBt3a0fg.mjs";
import { u as Y } from "./TabsListContext-Bcp97w7K.mjs";
import { u as Z } from "./useButton-CQeWQM5o.mjs";
const N = /* @__PURE__ */ n.forwardRef(function(a, i) {
  const {
    className: c,
    disabled: t = !1,
    render: g,
    value: o,
    id: u,
    nativeButton: P = !0,
    ...C
  } = a, {
    value: l,
    getTabPanelIdByTabValueOrIndex: M,
    orientation: R
  } = X(), {
    activateOnFocus: h,
    highlightedTabIndex: y,
    onTabActivation: E,
    setHighlightedTabIndex: m
  } = Y(), b = q(u), O = n.useMemo(() => ({
    disabled: t,
    id: b,
    value: o
  }), [t, b, o]), {
    compositeProps: j,
    compositeRef: B,
    index: e
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = J({
    metadata: O
  }), I = o ?? e, r = n.useMemo(() => o === void 0 ? e < 0 ? !1 : e === l : o === l, [e, l, o]), d = n.useRef(!1);
  W(() => {
    if (d.current) {
      d.current = !1;
      return;
    }
    r && e > -1 && y !== e && m(e);
  }, [r, e, y, m, t]);
  const {
    getButtonProps: w,
    buttonRef: D
  } = Z({
    disabled: t,
    native: P,
    focusableWhenDisabled: !0
  }), V = e > -1 ? M(o, e) : void 0, f = n.useRef(!1), p = n.useRef(!1), _ = T((s) => {
    r || t || E(I, s.nativeEvent);
  }), k = T((s) => {
    r || (e > -1 && m(e), !t && (h && !f.current || // keyboard focus
    f.current && p.current) && E(I, s.nativeEvent));
  }), A = T((s) => {
    if (r || t)
      return;
    f.current = !0;
    function F() {
      f.current = !1, p.current = !1;
    }
    (!s.button || s.button === 0) && (p.current = !0, S(s.currentTarget).addEventListener("pointerup", F, {
      once: !0
    }));
  }), L = n.useMemo(() => ({
    disabled: t,
    selected: r,
    orientation: R
  }), [t, r, R]);
  return z("button", a, {
    state: L,
    ref: [i, D, B],
    props: [j, {
      role: "tab",
      "aria-controls": V,
      "aria-selected": r,
      id: b,
      onClick: _,
      onFocus: k,
      onPointerDown: A,
      [G]: r ? "" : void 0,
      onKeyDownCapture() {
        d.current = !0;
      }
    }, C, w]
  });
});
process.env.NODE_ENV !== "production" && (N.displayName = "TabsTab");
const $ = H({
  base: [
    "Tab__root",
    "flex",
    "items-center",
    "justify-center",
    "border-0",
    "px-3",
    "h-10",
    "text-base",
    "tracking-normal",
    "font-regular",
    "text-gray-600",
    "outline-none",
    "select-none",
    "before:inset-x-0",
    "before:inset-y-1",
    "before:rounded-lg",
    "before:-outline-offset-1",
    "before:outline-blue-800",
    "hover:text-gray-900",
    "focus-visible:relative",
    "focus-visible:before:absolute",
    "focus-visible:before:outline",
    "focus-visible:before:outline-2",
    "transition-all",
    "duration-300",
    "ease-in-out",
    "data-[selected]:text-primary-main"
  ],
  variants: {}
}), ee = U((x, a) => {
  const { className: i, value: c, ...t } = x, g = K("sm");
  return /* @__PURE__ */ v.jsx(
    N,
    {
      ref: a,
      className: $({
        className: typeof i == "string" ? i : ""
      }),
      render: ({ className: o, ...u }) => g ? /* @__PURE__ */ v.jsx(Q, { ...u, value: c }) : /* @__PURE__ */ v.jsx("button", { className: o, ...u }),
      value: c,
      ...t
    }
  );
});
ee.displayName = "Tab";
export {
  ee as default
};
